const $ = require('./sukoa-jquery.cjs');
const sukoaUtils = require('./sukoaUtils').default;
export default {
    $animatedbody: null,
    $animOverlay: null,
    $animWrapper: null,
    $branding: null,
    $whitebg: null,
    $whiteVertiBorder: null,
    $whiteHoriBorder: null,
    $button: null,
    animWrapperHeight: null,
    animWrapperWidth: null,
    isHome: false,
    init: function() {
        let self = this ;
        self.$animatedbody = $("body.animation");


        if(self.$animatedbody.size() > 0) {
            self.$animWrapper = $("#animation-wrapper");

            if(self.$animWrapper.size() > 0) {
                self.$branding = $("#branding");
                if (self.$animatedbody.attr("id") === "home") {
                    self.isHome = true;
                }

                if (self.isHome) {
                    let r = 0;
                    let $overlayAnimCollec = self.$animWrapper.find(".overlay-animation");
                    let random = Math.round(Math.random() * ($overlayAnimCollec.size()) - 0.5);
                    self.$animOverlay = $("#overlay-animation-" + random);
                    $overlayAnimCollec.remove();
                    self.$animWrapper.prepend(self.$animOverlay);
                } else {
                    self.$animOverlay = $("#overlay-animation");
                }

                self.$whitebg = self.$animOverlay.find(".whitebg");
                self.$animOverlay.css({display: "block"});
                self.animOverlayHeight = self.$animOverlay.outerHeight(true);

                self.$whiteVertiBorder = self.$animWrapper.find(".verticalborder");
                self.$whiteHoriBorder = self.$animWrapper.find(".horizontalborder");
                self.$button = self.$animWrapper.find(".round-button");


                $(window).resize(function () {
                    self.animOverlayHeight = self.$animOverlay.outerHeight(true);
                });

                self.buttonTriggerListener(self);

                self.headerImageAnimation(self);
            }
        }
    },

    headerImageAnimation: function(self) {
        let doc = document.documentElement;
        let $svgtexts = self.$animWrapper.find("svg.transparent-text");

        self.$branding.addClass("animfix");
        let posNeg= 1;
        if(Math.random()<0.5){
            posNeg = -1;
        }

        function animation () {
            window.requestAnimationFrame(animation);
            let top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            if (self.isHome) {
                let skewval = 45 * top / (self.animOverlayHeight / 2);
                if (skewval < 0) {
                    skewval = 0;

                } else if (skewval > 45) {
                    skewval = 45;
                    $svgtexts.css("visibility", "hidden");
                }
                self.$whitebg.css({"transform": "skew(" + (posNeg * skewval) + "deg," + (posNeg * skewval) + "deg)"});
            }


            let corrector = 0;
            let projectCorrector = 0;
            if (self.isHome) {
                corrector = self.animOverlayHeight;
            } else {
                projectCorrector = -100;
            }

            let skewval2 = 45 * (top - corrector) / (self.animOverlayHeight + projectCorrector);

            if (skewval2 <= 0) {
                skewval2 = 0;
                if (self.$button.hasClass("hide")) {
                    self.$button.removeClass("hide");
                }
                // self.$branding.removeClass('bg');

            } else if (skewval2 > 45) {
                skewval2 = 45;
                if (!self.$button.hasClass("hide")) {
                    self.$button.addClass("hide");
                }
                // self.$branding.addClass('bg');

            } else {
                if (!self.$button.hasClass("hide")) {
                    self.$button.addClass("hide");
                }
                // self.$branding.removeClass('bg');
            }

            let verticalborderwidth = (self.animOverlayHeight + 10) * (skewval2 / 45);
            let horizontalborderwidth = (self.animOverlayHeight + 10) * (skewval2 / 45);
            if (self.isHome && top <= self.animOverlayHeight / 2) {
                $svgtexts.css("visibility", "visible");
                verticalborderwidth = 0;
                horizontalborderwidth = 0;
            }

            if (self.isHome) {
                self.$whiteVertiBorder.css("border-width", "0 100vw " + verticalborderwidth + "px 0");
                self.$whiteHoriBorder.css("border-width", "100vh 0 0 " + horizontalborderwidth + "px");
            } else {
                self.$whiteVertiBorder.css("border-bottom-width", verticalborderwidth + "px");
                self.$whiteHoriBorder.css("border-left-width", horizontalborderwidth + "px");
            }
        }
        animation();

    },

    buttonTriggerListener: function(self) {

        self.$button.click(function(e){
            e.stopPropagation();e.preventDefault();
            let doc = document.documentElement;
            let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

            if(top <= self.animOverlayHeight/2) {
                $("body,html").animate({scrollTop: self.animOverlayHeight}, 700);
            } else {
                $("body,html").animate({scrollTop: self.animOverlayHeight*2}, 700);
            }
        });
    }
};
